"use client";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";

interface Props {
  locale: string;
}

export default function PreviewModeBar({ locale }: Props) {
  const pathname = usePathname();

  const [insideIframe, setInsideIframe] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined" || window === window.parent) {
      setInsideIframe(false);
    }
    ContentfulLivePreview.init({
      locale: locale,
      debugMode: true,
      enableLiveUpdates: true,
      enableInspectorMode: true,
    });

    ContentfulLivePreview.subscribe("save", {
      callback: async () => {
        window.location.reload();
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full z-[100] bg-[#ffbf00] flex justify-between items-center p-m fixed bottom-0">
      {insideIframe ? (
        <>
          <p>Preview mode is active, you&apos;re seeing the draft version of this page.</p>
        </>
      ) : (
        <>
          <p>Preview mode is active, but you&apos;re not currenty in Contentful.</p>
          <Button
            href={location.origin + `/api/disable-draft-mode?redirectTo=${pathname}`}
            target="_self"
            size={ButtonSize.SMALL}
            variant={ButtonVariant.PRIMARY}
            theme={ButtonTheme.WHITE}
          >
            Exit preview mode
          </Button>
        </>
      )}
    </div>
  );
}
